import * as React from 'react';

import type { DimeActionToolbarIcon } from '../DimeActionToolbar/DimeActionToolbar.types.js';
import { cn } from './utils.js';

export function withToolbarIconProps(icon: DimeActionToolbarIcon, toneClassName?: string) {
  return React.cloneElement(icon, {
    'aria-hidden': true,
    className: cn('size-4 shrink-0', toneClassName, icon.props.className),
  });
}
